document.addEventListener(
  'click',
  function (event) {
    const reviewTrigger = event.target.closest(
      '.st-product-judgeme-review-title, .jdgm-preview-badge, .jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text'
    );

    const sidebarBlock = document.querySelector('.st-sidebar-reviews-block');
    const sidebarInnerBlock = document.querySelector('.st-sidebar-reviews-innerblock');
    const closeBtn = event.target.closest('.st-sidebar-reviews-close-icon');

    if (!sidebarBlock || !sidebarInnerBlock) return;

    function openSidebar() {
      sidebarBlock.classList.add('active');

      setTimeout(function () {
        sidebarInnerBlock.classList.add('active');
      }, 10);

      document.documentElement.classList.add('st-reviews-sidebar-open');
      document.body.classList.add('st-reviews-sidebar-open');
    }

    function closeSidebar() {
      sidebarInnerBlock.classList.remove('active');

      setTimeout(function () {
        sidebarBlock.classList.remove('active');
        document.documentElement.classList.remove('st-reviews-sidebar-open');
        document.body.classList.remove('st-reviews-sidebar-open');
      }, 300);
    }

    // Open sidebar
    if (reviewTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();

      openSidebar();
      return;
    }

    // Close sidebar from close icon
    if (closeBtn) {
      closeSidebar();
    }

    // Close sidebar when clicking overlay
    if (event.target.classList.contains('st-sidebar-reviews-block')) {
      closeSidebar();
    }
  },
  true
);



// Product Page Header 
  document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains("product")) return;

    const header = document.querySelector("#header");
    if (!header) return;

    function handleScroll() {
        if (window.innerWidth > 620) return;

        if (window.scrollY > 50) {
            header.classList.add("hide-mobile-fixed"); // smooth hide
        } else {
            header.classList.remove("hide-mobile-fixed"); // smooth show
        }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    handleScroll();
});



// Video
document.addEventListener('DOMContentLoaded', () => {
  const videoWrappers = document.querySelectorAll('.product-banner-video-wraper, .hero-banner');

  videoWrappers.forEach(wrapper => {
    const { 
      video, 
      playPauseBtn, 
      forwardBtn, 
      fullscreenBtn, 
      progressBar, 
      progressContainer, 
      visualizer 
    } = {
      video: wrapper.querySelector('.video'),
      playPauseBtn: wrapper.querySelector('.playPauseBtn'),
      forwardBtn: wrapper.querySelector('.forwardBtn'),
      fullscreenBtn: wrapper.querySelector('.fullscreenBtn'),
      progressBar: wrapper.querySelector('.progressBar'),
      progressContainer: wrapper.querySelector('.progressContainer'),
      visualizer: wrapper.querySelector('.visualizer')
    };

    const volumeBtn = wrapper.querySelector('.Volumn-btn'); 
    const soundOnIcon = volumeBtn?.querySelector('.sound-on');
    const soundOffIcon = volumeBtn?.querySelector('.sound-off');

    if (!video) return;

    // --- Play / Pause toggle ---
    const togglePlayPauseClasses = (isPaused) => {
      playPauseBtn?.classList.toggle('playing', !isPaused);
      playPauseBtn?.classList.toggle('paused', isPaused);
      if (visualizer) {
        visualizer.classList.toggle('playing', !isPaused);
      }
    };
    
    const handleVideoState = (state) => {
      togglePlayPauseClasses(state === 'paused' || state === 'ended');
    };

    if (video) {
      video.play()
        .then(() => handleVideoState('playing'))
        .catch(err => {
          console.warn("Autoplay prevented:", err);
          handleVideoState('paused');
        });
    }

    playPauseBtn?.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video?.addEventListener('play', () => handleVideoState('playing'));
    video?.addEventListener('pause', () => handleVideoState('paused'));
    video?.addEventListener('ended', () => handleVideoState('ended'));

    forwardBtn?.addEventListener('click', () => {
      video.currentTime += 3;
    });

    // --- Fullscreen (cross-browser + iOS Safari) ---
    fullscreenBtn?.addEventListener('click', () => {
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      } else {
        // Enter fullscreen
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          // iOS Safari
          video.webkitEnterFullscreen();
        }
      }
    });

    video?.addEventListener('timeupdate', () => {
      if (progressBar) {
        progressBar.style.width = `${(video.currentTime / video.duration) * 100}%`;
      }
    });

    progressContainer?.addEventListener('click', (e) => {
      const rect = progressContainer.getBoundingClientRect();
      const percent = (e.clientX - rect.left) / rect.width;
      video.currentTime = percent * video.duration;
    });

    // --- Volume toggle ---
    volumeBtn?.addEventListener('click', () => {
      video.muted = !video.muted;

      if (video.muted) {
        soundOnIcon?.classList.remove('active');
        soundOffIcon?.classList.add('active');
      } else {
        soundOnIcon?.classList.add('active');
        soundOffIcon?.classList.remove('active');
      }
    });
  });
});



// ------------------
// ------------------
// -----------------
document.addEventListener("DOMContentLoaded", function () {
  const viewAllColorsBtn = document.querySelector(".st-view-all-colors-btn");
  const viewColorsBlock = document.querySelector(".st-view-the-colors-block");
  const closeColorsBtn = document.querySelector(".st-view-the-colors-close-icons");
  const htmlEl = document.documentElement;

  if (viewAllColorsBtn && viewColorsBlock && closeColorsBtn) {
    // Open
    viewAllColorsBtn.addEventListener("click", function () {
      viewColorsBlock.classList.add("active");
      htmlEl.classList.add("overflow-hidden");
    });

    // Close
    closeColorsBtn.addEventListener("click", function () {
      viewColorsBlock.classList.remove("active");
      htmlEl.classList.remove("overflow-hidden");
    });
  }
});


// ---------------------- 
// ----------------------
// Product page related 
// ----------------------
// ----------------------


// new
document.addEventListener("DOMContentLoaded", function () {
  // --- Init Swiper ---
  const galleryElement = document.querySelector(".product-gallery-swiper");
  if (!galleryElement || typeof Swiper !== "function") return;

  const swiper = new Swiper(galleryElement, {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // MULTI: grab ALL matching nodes
  const variantIdInputs = document.querySelectorAll(
    'form[action*="/cart/add"] input[name="id"]'
  );
  const addToCartForms = document.querySelectorAll(".st-product-info-content-form");
  const waitlistBlocks = document.querySelectorAll(".st-product-info-content-waitlist-btn-block");

  function normalize(url) {
    if (!url) return "";
    return url.split("?")[0].replace(/\/+$/, "");
  }

  function findSlideIndexBySrc(variantImg) {
    if (!variantImg) return null;
    const v = normalize(variantImg);
    const slides = document.querySelectorAll(
      ".product-gallery-swiper .swiper-slide img"
    );
    for (let i = 0; i < slides.length; i++) {
      const s = normalize(slides[i].getAttribute("src") || "");
      if (!s) continue;
      if (s === v || s.endsWith(v) || v.endsWith(s)) return i;
    }
    return null;
  }

  // MULTI: toggle all add-to-cart / waitlist blocks
  function toggleAvailability(isAvailable) {
    const soldOutBadge = document.querySelector(".st-product-info-content-sold-out-badge");

    if (isAvailable) {
      addToCartForms.forEach((el) => (el.style.display = "block"));
      waitlistBlocks.forEach((el) => (el.style.display = "none"));
      if (soldOutBadge) soldOutBadge.style.display = "none";
    } else {
      addToCartForms.forEach((el) => (el.style.display = "none"));
      waitlistBlocks.forEach((el) => (el.style.display = "block"));
      if (soldOutBadge) soldOutBadge.style.display = "flex";
    }
  }

  // Helper to update ALL variant id inputs
  function setVariantIdOnAllInputs(vid) {
    if (!vid) return;
    variantIdInputs.forEach((input) => {
      input.value = vid;
      // fire change for any listeners
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function updateVariantUrl(vid) {
    if (!vid) return;

    const url = new URL(window.location.href);

    // If same variant already exists, do nothing
    if (url.searchParams.get("variant") === vid) return;

    url.searchParams.set("variant", vid);
    window.history.replaceState({}, "", url.toString());
  }

  function updateOtherSystem(currentSwatch, allSystems) {
    const vid = currentSwatch.getAttribute("variant-id");
    if (!vid) return;

    allSystems.forEach(({ swatches, titleSpan }) => {
      swatches.forEach((s) => {
        if (s.getAttribute("variant-id") === vid) {
          swatches.forEach((x) => x.classList.remove("active"));
          s.classList.add("active");
          if (titleSpan)
            titleSpan.textContent = currentSwatch.getAttribute("title") || "";
        }
      });
    });
  }

  function initSwatchSystem(
    { containerSelector, swatchSelector, titleSelector },
    allSystems
  ) {
    const container = document.querySelector(containerSelector);
    const swatches = document.querySelectorAll(swatchSelector);
    const titleSpan = document.querySelector(titleSelector);

    if (!container || !swatches.length || !titleSpan) return;

    let savedIndex = null;
    let hovering = false;
    let permanentIndex = null;
    let permanentTitle = titleSpan.textContent || "";

    // Init active swatch
    (function tryInitActive() {
      const urlVariantId = new URLSearchParams(window.location.search).get("variant");

      const initialActive =
        (urlVariantId && container.querySelector(`${swatchSelector}[variant-id="${urlVariantId}"]`)) ||
        container.querySelector(`${swatchSelector}.active`);

      if (initialActive) {
        swatches.forEach((s) => s.classList.remove("active"));
        initialActive.classList.add("active");

        const title = initialActive.getAttribute("title");
        const img = initialActive.getAttribute("variant-image");
        const vid = initialActive.getAttribute("variant-id");

        if (title) {
          permanentTitle = title;
          titleSpan.textContent = permanentTitle;
        }

        if (img) {
          const idx = findSlideIndexBySrc(img);
          if (idx !== null) {
            permanentIndex = idx;
            swiper.slideTo(idx, 0);
          }
        }

        if (vid) {
          setVariantIdOnAllInputs(vid);

          // Only add variant to URL if URL does not already have variant
          if (!urlVariantId) {
            updateVariantUrl(vid);
          }
        }

        const isAvailable =
          initialActive.getAttribute("variant-available") === "true";

        toggleAvailability(isAvailable);
      } else {
        savedIndex = swiper.activeIndex;
      }
    })();

    // Hover
    container.addEventListener("mouseover", function (e) {
      const swatch = e.target.closest(swatchSelector);
      if (!swatch || !container.contains(swatch)) return;

      if (!hovering) {
        savedIndex =
          typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0;
        hovering = true;
      }

      const newTitle = swatch.getAttribute("title");
      if (newTitle) titleSpan.textContent = newTitle;

      const variantImg = swatch.getAttribute("variant-image");
      const idx = findSlideIndexBySrc(variantImg);
      if (idx !== null) swiper.slideTo(idx);
    });

    // Mouse leave
    container.addEventListener("mouseleave", function () {
      hovering = false;
      titleSpan.textContent = permanentTitle;

      if (permanentIndex !== null) {
        swiper.slideTo(permanentIndex);
      } else if (savedIndex !== null) {
        swiper.slideTo(savedIndex);
      }
    });

    // Click
    swatches.forEach((swatch) => {
      swatch.addEventListener("click", function () {
        swatches.forEach((s) => s.classList.remove("active"));
        this.classList.add("active");

        const newTitle = this.getAttribute("title");
        if (newTitle) {
          permanentTitle = newTitle;
          titleSpan.textContent = permanentTitle;
        }

        const variantId = this.getAttribute("variant-id");
        if (variantId) {
          // MULTI: set all inputs
          setVariantIdOnAllInputs(variantId);
          // Update URL when user changes color
  updateVariantUrl(variantId);


        }

        const img = this.getAttribute("variant-image");
        const idx = findSlideIndexBySrc(img);
        if (idx !== null) {
          permanentIndex = idx;
          swiper.slideTo(idx);
        }

        // Availability toggle
        const isAvailable = this.getAttribute("variant-available") === "true";
        toggleAvailability(isAvailable);

        // Sync with other system
        updateOtherSystem(this, allSystems);
      });
    });

    // Sync savedIndex if slide changes
    swiper.on &&
      swiper.on("slideChange", function () {
        if (!hovering && permanentIndex === null) {
          savedIndex = swiper.activeIndex;
        }
      });

    return { swatches, titleSpan };
  }

  // Initialize both systems and link them
  const allSystems = [];

  allSystems.push(
    initSwatchSystem(
      {
        containerSelector: ".st-product-info-content-variant-color-box-area",
        swatchSelector: ".st-product-info-content-variant-color-swatch",
        titleSelector: ".st-product-info-content-variant-text-area span",
      },
      allSystems
    )
  );

  allSystems.push(
    initSwatchSystem(
      {
        containerSelector: ".st-view-the-colors-content-grid",
        swatchSelector: ".st-view-the-colors-content",
        titleSelector: ".st-view-the-colors-content-title span",
      },
      allSystems
    )
  );

  // --- NEW: Check if whole product is unavailable ---
  const allSwatches = document.querySelectorAll(
    ".st-product-info-content-variant-color-swatch, .st-view-the-colors-content"
  );
  if (allSwatches.length > 0) {
    const atLeastOneAvailable = Array.from(allSwatches).some(
      (s) => s.getAttribute("variant-available") === "true"
    );
    if (!atLeastOneAvailable) {
      // Whole product sold out
      toggleAvailability(false);
    }
  }

  // Make sure updateOtherSystem can see both
  allSystems.forEach((sys) => {
    if (sys && sys.swatches) {
      sys.swatches.forEach((swatch) => {
        swatch.addEventListener("click", function () {
          updateOtherSystem(this, allSystems);
        });
      });
    }
  });
});




// -----------------
// -----------------
// -----------------
document.addEventListener("DOMContentLoaded", function () {
    const titleBlocks = document.querySelectorAll(".st-product-info-content-sizes-title-block");

    titleBlocks.forEach(title => {
        title.addEventListener("click", function () {
            const grid = this.nextElementSibling; // Assuming grid is right after title
            if (!grid) return;

            // Toggle active class
            this.classList.toggle("active");
            grid.classList.toggle("active");

            // Slide toggle logic
            if (grid.style.maxHeight) {
                grid.style.maxHeight = null; // Close
            } else {
                grid.style.maxHeight = grid.scrollHeight + "px"; // Open
            }
        });
    });
});


// mobile btns

document.addEventListener("DOMContentLoaded", function () {
  const notSticky = document.querySelector(".st-sticky-product-btns.mobile.st-not-sticky");
  const sticky = document.querySelector(".st-sticky-product-btns.mobile.st-be-sticky");
  const section = document.querySelector(".st-product-info-block");

  if (!notSticky || !sticky || !section) return;

  // start hidden
  sticky.classList.remove("active");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const sectionInView = section.getBoundingClientRect().top < window.innerHeight &&
                            section.getBoundingClientRect().bottom > 0;

      const buttonVisible = entry.isIntersecting;

      if (sectionInView && !buttonVisible) {
        // Inside section AND button not visible → show sticky
        sticky.classList.add("active");
      } else {
        // Either outside section OR button visible → hide sticky
        sticky.classList.remove("active");
      }
    });
  }, { threshold: 0.1 });

  observer.observe(notSticky);

  // Also watch scroll to cover section in/out changes
  window.addEventListener("scroll", () => {
    const sectionInView = section.getBoundingClientRect().top < window.innerHeight &&
                          section.getBoundingClientRect().bottom > 0;
    const buttonVisible = notSticky.getBoundingClientRect().top < window.innerHeight &&
                          notSticky.getBoundingClientRect().bottom > 0;

    if (sectionInView && !buttonVisible) {
      sticky.classList.add("active");
    } else {
      sticky.classList.remove("active");
    }
  });
});


// ------------------
// ------------------
// ------------------


// new
document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.querySelector(".st-tabbing-block-overlay");
    const closeBtn = overlay?.querySelector(".st-tabbing-close-icons");

    // Desktop bottom tabs
    const desktopTabs = document.querySelectorAll(
        ".st-product-info-content-bottom-details.desktop, " +
        ".st-product-info-content-bottom-devlivery-returns.desktop, " +
        ".st-product-info-content-bottom-care.desktop"
    );

    // Drawer tabs inside overlay
    const drawerTabs = document.querySelectorAll(
        ".st-tabbing-drawer-detail-tab, .st-tabbing-drawer-devlivery-returns-tab, .st-tabbing-drawer-care-tab"
    );

    // Tab content areas
    const tabContents = {
        details: overlay?.querySelector(".st-detail-tab-content-area"),
        returns: overlay?.querySelector(".st-devlivery-returns-tab-content-area"),
        care: overlay?.querySelector(".st-care-tab-content-area")
    };

    function clearActive() {
        desktopTabs.forEach(t => t.classList.remove("active"));
        drawerTabs.forEach(t => t.classList.remove("active"));
        Object.values(tabContents).forEach(c => c.classList.remove("active"));
    }

    function activate(type) {
        clearActive();

        if (type === "details") {
            desktopTabs.forEach(t => {
                if (t.classList.contains("st-product-info-content-bottom-details")) t.classList.add("active");
            });
            drawerTabs.forEach(t => {
                if (t.classList.contains("st-tabbing-drawer-detail-tab")) t.classList.add("active");
            });
            tabContents.details?.classList.add("active");
        }

        if (type === "returns") {
            desktopTabs.forEach(t => {
                if (t.classList.contains("st-product-info-content-bottom-devlivery-returns")) t.classList.add("active");
            });
            drawerTabs.forEach(t => {
                if (t.classList.contains("st-tabbing-drawer-devlivery-returns-tab")) t.classList.add("active");
            });
            tabContents.returns?.classList.add("active");
        }

        if (type === "care") {
            desktopTabs.forEach(t => {
                if (t.classList.contains("st-product-info-content-bottom-care")) t.classList.add("active");
            });
            drawerTabs.forEach(t => {
                if (t.classList.contains("st-tabbing-drawer-care-tab")) t.classList.add("active");
            });
            tabContents.care?.classList.add("active");
        }
    }

    // Click desktop bottom tabs → open overlay
    desktopTabs.forEach(tab => {
        tab.addEventListener("click", () => {
            if (tab.classList.contains("st-product-info-content-bottom-details")) activate("details");
            if (tab.classList.contains("st-product-info-content-bottom-devlivery-returns")) activate("returns");
            if (tab.classList.contains("st-product-info-content-bottom-care")) activate("care");

            overlay?.classList.add("active");
            document.documentElement.classList.add("overflow-hidden");
        });
    });

    // Click drawer tabs → switch content only
    drawerTabs.forEach(tab => {
        tab.addEventListener("click", () => {
            if (tab.classList.contains("st-tabbing-drawer-detail-tab")) activate("details");
            if (tab.classList.contains("st-tabbing-drawer-devlivery-returns-tab")) activate("returns");
            if (tab.classList.contains("st-tabbing-drawer-care-tab")) activate("care");
        });
    });

    // Close overlay
    closeBtn?.addEventListener("click", () => {
        overlay?.classList.remove("active");
        document.documentElement.classList.remove("overflow-hidden");
        clearActive();
    });
});


document.addEventListener("DOMContentLoaded", function () {
    // --- Mobile tabs ---
    const mobileTabs = document.querySelectorAll(".st-product-info-content-bottom-innerblock.mobile span");
    const mobileContents = {
        details: document.querySelector(".st-detail-tab-content-area.mobile"),
        returns: document.querySelector(".st-devlivery-returns-tab-content-area.mobile"),
        care: document.querySelector(".st-care-tab-content-area.mobile")
    };

    function clearMobileActive() {
        mobileTabs.forEach(tab => tab.classList.remove("active"));
        Object.values(mobileContents).forEach(content => content.classList.remove("active"));
    }

    function activateMobileTab(type) {
        clearMobileActive();

        if (type === "details") {
            mobileTabs.forEach(tab => {
                if (tab.classList.contains("st-product-info-content-bottom-details")) tab.classList.add("active");
            });
            mobileContents.details?.classList.add("active");
        }
        if (type === "returns") {
            mobileTabs.forEach(tab => {
                if (tab.classList.contains("st-product-info-content-bottom-devlivery-returns")) tab.classList.add("active");
            });
            mobileContents.returns?.classList.add("active");
        }
        if (type === "care") {
            mobileTabs.forEach(tab => {
                if (tab.classList.contains("st-product-info-content-bottom-care")) tab.classList.add("active");
            });
            mobileContents.care?.classList.add("active");
        }
    }

    mobileTabs.forEach(tab => {
        tab.addEventListener("click", () => {
            if (tab.classList.contains("st-product-info-content-bottom-details")) activateMobileTab("details");
            if (tab.classList.contains("st-product-info-content-bottom-devlivery-returns")) activateMobileTab("returns");
            if (tab.classList.contains("st-product-info-content-bottom-care")) activateMobileTab("care");
        });
    });
});




// ------------------
// cart drawer
// ------------------



document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector(".st-cart-drawer-block");
  if (!cartDrawer) return;
  const htmlTag = document.documentElement;
  const sectionId = cartDrawer.getAttribute("section-id");

  // --- OPEN cart drawer ---
  document.addEventListener("click", function (e) {
    if (e.target.closest(".cart-open")) {
      cartDrawer.classList.add("active");
      htmlTag.style.overflowY = "hidden";
    }
  });

  // --- CLOSE cart drawer ---
  document.addEventListener("click", function (e) {
    if (e.target.closest(".cart-close")) {
      cartDrawer.classList.remove("active");
      htmlTag.style.overflowY = "";
    }
  });

  // --- REMOVE item ---
  document.addEventListener("click", function (e) {
    if (e.target.closest(".st-cart-drawer-item-remove")) {
      e.preventDefault();
      const button = e.target.closest(".st-cart-drawer-item-remove");
      const lineItemKey = button.dataset.lineItemKey;
      if (!lineItemKey) return console.error("Missing line item key");

      updateLineItem(lineItemKey, 0);
    }
  });

  // --- PLUS/MINUS quantity ---
  document.addEventListener("click", function (e) {
    if (e.target.closest(".quantity-plus") || e.target.closest(".quantity-minus")) {
      e.preventDefault(); // Stop page reload

      const btn = e.target.closest("button");
      const input = btn.parentElement.querySelector("input");
      const lineItemKey = input.dataset.lineItemKey;
      let qty = parseInt(input.value, 10) || 1;

      if (btn.classList.contains("quantity-plus")) {
        qty++;
      } else if (btn.classList.contains("quantity-minus") && qty > 1) {
        qty--;
      }

      updateLineItem(lineItemKey, qty);
    }
  });

  // --- ADD to cart ---
  document.addEventListener("submit", function (e) {
    if (e.target.matches("form[action='/cart/add']")) {
      e.preventDefault();
      const formData = new FormData(e.target);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(res => res.json())
        .then(() => {
          cartDrawer.classList.add("active");
          htmlTag.style.overflowY = "hidden";
          updateCartDrawer();
        })
        .catch(err => console.error("Add to cart failed:", err));
    }
  });

  // --- Update single line item ---
  function updateLineItem(lineItemKey, quantity) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates: { [lineItemKey]: quantity } })
    })
      .then(res => res.json())
      .then(() => updateCartDrawer())
      .catch(err => console.error("Quantity update failed:", err));
  }

  // --- Refresh cart drawer ---
  function updateCartDrawer() {
    fetch(`/?section_id=${sectionId}`)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newContent = doc.querySelector(".st-cart-drawer-block").innerHTML;
        cartDrawer.innerHTML = newContent;

        // update header count too
        updateCartCount();
      })
      .catch(err => console.error("Cart drawer update failed:", err));
  }

  // --- Update cart count in header ---
  function updateCartCount() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const countSpan = document.querySelector(".product-item-count");
        if (countSpan) {
          countSpan.textContent = cart.item_count;
        }
      })
      .catch(err => console.error("Cart count update failed:", err));
  }
});


// fix nested waitlist button click
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.st-collection-product-waitlist-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });
});



// open klayio form
document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with class 'klayio-form'
    const klayioButtons = document.querySelectorAll('.klayio-form');

    klayioButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Ensure the Klaviyo _klOnsite object exists
            window._klOnsite = window._klOnsite || [];
            
            // Trigger the popup form (replace 'Th95Tf' with your actual form ID)
            window._klOnsite.push(['openForm', 'Th95Tf']);
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "function") {
    document.querySelectorAll(".st-product-grid-with-images-left-side-product-swiper").forEach((swiperElement) => {
      if (swiperElement.classList.contains("swiper-loaded")) return;

      const productBlock = swiperElement.closest(".st-product-grid-with-images-left-side-product-block");
      new Swiper(swiperElement, {
        navigation: {
          nextEl: productBlock?.querySelector(".st-product-grid-with-images-left-side-product-swiper-button-next"),
          prevEl: productBlock?.querySelector(".st-product-grid-with-images-left-side-product-swiper-button-prev"),
        },
      });

      swiperElement.classList.add("swiper-loaded");
    });
  }

  const gridSections = document.querySelectorAll(".st-product-grid-with-images-innerblock");
  if (!gridSections.length) return;

  function syncHeights() {
    gridSections.forEach((gridSection) => {
      const left = gridSection.querySelector(".st-product-grid-with-images-left-side");
      const right = gridSection.querySelector(".st-product-grid-with-images-right-side-img-block img");

      if (!left || !right) return;

      if (window.innerWidth < 768) {
        right.style.height = "";
        return;
      }

      right.style.height = "auto";
      const leftHeight = left.offsetHeight;

      if (leftHeight > 0) {
        right.style.height = leftHeight + "px";
      }
    });
  }

  syncHeights();
  window.addEventListener("resize", syncHeights);
});